import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Box } from "@mui/material";
import { HomeLink } from "./components/HomeLink";
import { NavigationLinks } from "./components/NavigationLinks";
import { AnimatedRoutes } from "./components/Routes";

function App() {
  return (
    <Router>
      <Box
        bgcolor="background.paper"
        width="100%"
        height="100%"
        minHeight={600}
        position="relative"
      >
        <Box
          bgcolor="background.paper"
          position={"absolute"}
          top={0}
          left={0}
          right={0}
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          px={4}
          pt={4}
          pb={2}
          zIndex={10}
        >
          <HomeLink />
          <NavigationLinks />
        </Box>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            overflow: "auto",
          }}
        >
          <AnimatedRoutes />
        </Box>
      </Box>
    </Router>
  );
}

export default App;
